import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator' ;
import { ContentLoader } from 'vue-content-loader' ;


@Component({
    components: {
        ContentLoader
    }
})
class ProfilePaginationLoader extends Vue {

    @Prop({ default: 'avatar', type: [String] })
    loaderType: 'avatar' | 'column' | 'multi-column'

    dtColumn: {
        width: number;
        height: number;
    }

    dtHeaderColumn: {
        width: number;
        height: number;
    }

    dtRadius: number

    constructor(){
        super()

        this.dtColumn = {
            width: 60,
            height: 7
        }

        this.dtHeaderColumn= {
            width: 60,
            height: 12
        }

        this.dtRadius= 13
    }
} 

export default ProfilePaginationLoader


// WEBPACK FOOTER //
// ./src/containers/profile/loaders/profile-pagination-loader/index.ts